import { START_PAGE } from "../../utils/Constant";
import { GET_ALL_CUSTOMER_DATA } from "./ActionTypes";

export const getAllCustomerData = (payload, currentPage = START_PAGE) => ({
    type: GET_ALL_CUSTOMER_DATA,
    payload,
    currentPage,
  });